import React from 'react';
import {withTranslation} from 'react-i18next';
import history from "../../utils/History";
import Spinner from "../../components/spinner/Spinner";

class ConvertiSegnalazione extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        let props = this.props.location.props
        history.push({
            pathname: props.path,
            malattia: props.malattia,
            nomePaziente: props.nomePaziente,
            cognomePaziente: props.cognomePaziente,
            dataDiNascita: props.dataDiNascita,
            focolai: props.focolai,
        });
    }

    render() {
        return (
            <div >
                <Spinner/>
            </div>
        )
    }
}

export default withTranslation('common')(ConvertiSegnalazione);
